import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { JsonObjectFactoryService } from '../../../global/services/json-object-factory.service';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AdminScreenContextService } from '../../shared/admin-screen-context.service';
import { resolveFilterParams } from '../../../shared/workspace-element-context';

const ACTIONS_GRID_URL = '/loadGridJson?action_id=79&grid_id=33';
const SAVE_ACTION_URL = '/saveAction';

@Injectable({
  providedIn: 'root',
})
export class AdminActionsService {
  constructor(
    private http: HttpClient,
    private jsonObjectFactory: JsonObjectFactoryService,
    private globalService: GlobalService,
    private workspaceService: WorkspaceService,
    private adminScreenContext: AdminScreenContextService,
  ) {}

  getActionsList(baseUrl: string, filter: Record<string, any>): Observable<any> {
    const url = `${baseUrl}${ACTIONS_GRID_URL}`;
    let params = new HttpParams();
    if (filter && typeof filter === 'object') {
      Object.keys(filter).forEach((k) => {
        const v = filter[k];
        if (v !== undefined && v !== null) {
          params = params.set(k, String(v));
        }
      });
    }
    return this.http.get<any>(url, {
      params,
      withCredentials: true,
    });
  }

  saveAction(adminApiUrl: string, data: { action_key: string; json_string: string }): Observable<any> {
    const url = `${adminApiUrl}${SAVE_ACTION_URL}`;

    const globalParams = this.globalService.global.globalParams;
    const filterParams: any = resolveFilterParams(this.adminScreenContext, this.workspaceService);

    const fd = new FormData();
    fd.append('action_key', data.action_key);
    fd.append('json_string', data.json_string);
    fd.append('jcd_key', globalParams.jcd_key ?? '');
    fd.append('issue_id', globalParams.issue_id ?? '');
    fd.append('issue_short_desc', globalParams.issue_short_desc ?? '');
    fd.append('checkLockedbj', JSON.stringify([{}]));

    if (filterParams.tax_year) {
      fd.append('tax_year', filterParams.tax_year);
    }
    if (filterParams.scenario) {
      fd.append('scenario', filterParams.scenario);
    }

    return this.http.post(url, fd).pipe(
      map((response: any) => response),
    );
  }

  /**
   * Load action detail - action_code mmcfpw.
   * Response includes: jsonObject (action data), validationRules, actionCacheMap.
   */
  getActionDetail(baseUrl: string, actionKey: number, versionNum: number, clientKey?: number): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    let httpParams = new HttpParams()
      .set('action_code', 'mmcfpw')
      .set('action_key', String(actionKey))
      .set('version_num', String(versionNum));
    if (clientKey !== undefined && clientKey !== null) {
      httpParams = httpParams.set('client_key', String(clientKey));
    }
    return this.http.get<any>(url, { params: httpParams, withCredentials: true });
  }

  /**
   * Load datasource list - action_id 83.
   */
  getDatasourceList(baseUrl: string): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.http.get<any>(url, { params: { action_id: '83' }, withCredentials: true });
  }

  /**
   * Load caching objects - action_code 12xqcg.
   */
  getCachingObjList(baseUrl: string, clientKey: string | number): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.http.get<any>(url, {
      params: { action_code: '12xqcg', client_key: String(clientKey) },
      withCredentials: true,
    });
  }

  getRoles(baseUrl: string, jcdTaKey: number | string): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.http.get<any>(url, {
      params: { action_id: '81', jcd_ta_key: String(jcdTaKey) },
      withCredentials: true,
    });
  }
}
